module.exports = new __parcel__URL__("report-cumulative-flow-diagram.d1059572.svg").toString();